export const numberOfferTableCells = () => {
  if (window.innerWidth > 767) {
    const offerTables = document.querySelectorAll(".offer-table--origin .offer-table__offers");
    
    if(offerTables) {
      offerTables.forEach(currentTable => {

        if(currentTable.classList.contains('offer-table__offers--cells-numbered')) {
          return;
        }

        const tableColumns = currentTable.querySelectorAll(".offer-column");

        tableColumns.forEach((currentColumn, columnIndex) => {
          const tableRows = currentColumn.querySelectorAll(".offer-item");
          
          tableRows.forEach((currentRow, rowIndex) => {
            currentRow.setAttribute("data-column-number", columnIndex);
            currentRow.setAttribute("data-row-number", rowIndex);
          })
        })

        currentTable.classList.add('offer-table__offers--cells-numbered');
        
      })
    }
  }
}